import { render, staticRenderFns } from "./detailMe.vue?vue&type=template&id=073ee7bc"
import script from "./detailMe.vue?vue&type=script&lang=js"
export * from "./detailMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports